import { default as slices } from './slices';

export const Users = slices.users.reducer;

export default Users;
